import { TextBox } from "../core/components/textBox.js";
import { ConversationHistory, TicketConversation } from "./conversationHistory.js";
import {DocumentReferenceType, Helper} from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { uploadDocument, uploadDocuments } from "../documents/documents.js";
import { EventType } from "../../siteManagement/eventManager.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import React from "react";
import Data = google.maps.Data;
export default class TicketText extends React.Component<any, any> {
    private _wrapperElementRef = null;
    private _conversationHistoryComp: ConversationHistory = null;
    private _count: number = 0;
    private _cancelImmediate: () => void;

    private _renderTextArea = () => {
        return (
            <TextBox {...this.props as any} />
        );
    }

    private handleAdd = (item: TicketConversation) => {
        if (this.props.field.model === "entity.Conversation") {
            switch (item.Type) {
                case 1:
                    this.props.entity.ProblemHistory.push(item);
                    this.props.onChange({ model: "entity.ProblemHistory" }, this.props.entity.ProblemHistory);
                    break;
                case 2:
                    this.props.entity.AnnotationHistory.push(item);
                    this.props.onChange({ model: "entity.AnnotationHistory" }, this.props.entity.AnnotationHistory);
                    break;
                case 3:
                    this.props.entity.SolutionHistory.push(item);
                    this.props.onChange({ model: "entity.SolutionHistory" }, this.props.entity.SolutionHistory);
                    break;
            }
        } else {
            this.conversation.push(item);

            this.props.onChange(this.props.field, this.conversation);
        }
    }

    private conversation: Array<TicketConversation> = null;

    private _renderConversation = () => {
        let type = null;
        //let data = null;
        let events = [];

        this.conversation = [];

        if (this.props.field.model === "entity.Conversation") {
            type = 1;

            this.conversation = this.conversation.concat(this.props.context.problemConversation);
            this.conversation = this.conversation.concat(this.props.context.annotationConversation);
            this.conversation = this.conversation.concat(this.props.context.solutionConversation);

            events = this.props.context.events;
        } else {

            if (this.props.field.model === "entity.Problem") {
                type = 1;
                this.conversation = this.conversation.concat(this.props.context.problemConversation);
                events = this.props.context.events;
            } else if (this.props.field.model === "entity.Anmerkung") {
                type = 2;
                this.conversation = this.conversation.concat(this.props.context.annotationConversation);
            } else if (this.props.field.model === "entity.Loesung") {
                type = 3;
                this.conversation = this.conversation.concat(this.props.context.solutionConversation);
            }
        }

        return (
            <div ref={(r) => this._wrapperElementRef = r}>
                <ConversationHistory
                    ref={(r) => this._conversationHistoryComp = r} {...this.props as any}
                    conversationType={type}
                    comments={this.conversation}
                    events={events}
                    onAdd={this.handleAdd}
                    noScrollbars={this.props.field.props ? this.props.field.props.noScrollbars : false}
                    inputboxPosition={this.props.field.props ? this.props.field.props.inputboxPosition : "bottom"}
                    additionalUrlParams={this.props.field.props ? this.props.field.props.additionalUrlParams : ''}
                    textToHighlight={this.props.context?.textToHighlight}
                />
            </div>
        );
    }

    private _setImmediate(callback: (...args: any[]) => void, ...args: any[]) {
        let cancelled = false;
        Promise.resolve().then(() => cancelled || callback(...args));
        return () => {
            cancelled = true;
        };
    }
    componentDidMount() {
        let that = this;
        if (that.props.field.model === "entity.Problem" || that.props.field.model === "entity.Conversation") {
            let dragElement = $(".sheet__content");
            if (dragElement.length != 1)
                dragElement = that._wrapperElementRef;
            //console.log("dragElement: ", dragElement);


            $(dragElement).on("dragover", (e) => {
                //console.log("dragover");
                e.preventDefault();
                e.originalEvent.dataTransfer.dropEffect = 'copy';
            });

            $(dragElement).on("dragenter", (e) => {
                e.preventDefault();
                //console.log("dragenter");

                if (that._count === 0) {
                    if (!that.props.entity.IsNew && that.props.entity.RecordRight.CanWrite) {
                        $(dragElement).css('border', '2px solid #0B85A1');
                        $(dragElement).css('opacity', '0.3');
                    }
                }
                ++that._count;
            });

            $(dragElement).on("dragleave", (e) => {
                e.preventDefault();
                //console.log("dragleave");

                that._cancelImmediate = that._setImmediate(() => {
                    --that._count;
                    if (that._count === 0) {
                        $(dragElement).css('border', '');
                        $(dragElement).css('opacity', '');
                    }
                })
            });

            $(dragElement).on('drop', async (e) => {
                e.preventDefault();

                if (that && that._cancelImmediate != undefined)
                    that._cancelImmediate();

                if (that._count > 0) {
                    that._count = 0;
                    if (!that.props.entity.IsNew && that.props.entity.RecordRight.CanWrite) {
                        $(dragElement).css('border', '');
                        $(dragElement).css('opacity', '');

                        if (!that.props.context.isEntitySaved()) {
                            DialogHelper.alert(Config.translations.saveDataFirst)
                            return;
                        }
                        
                        let dataTransfer = (e.originalEvent as DragEvent).dataTransfer;
                        const files = Array.from(dataTransfer.files);
                        // AP: Das neue Outlook erlaubt noch kein Drag and Drop von Mails und Attachments über den Browser -> Meldung für Aufklärung des Users
                        if(dataTransfer.types.includes('maillistrow') && dataTransfer.files.length === 0){
                            DialogHelper.alert(Helper.getTranslation("Dokument.NewOutlookDragAndDropWarning"));
                            return;
                        }

                        if (Config.settings.useDocumentAddWithCanCancel) {
                            uploadDocuments(null, files, DocumentReferenceType.Ticket, that.props.entity.ProblemNr, true, (_) => {
                                that.props.context.reloadEntity().then(() => {
                                    that._conversationHistoryComp.scrollAndFocusComponent();
                                    General.Events.trigger(EventType.Custom, { cmd: "refreshDocuments" });
                                });
                            }).then();
                        } else {

                            if (files.length == 1) {
                                uploadDocument(null, files[0], DocumentReferenceType.Ticket, that.props.entity.ProblemNr, false, (_) => {
                                    that.props.context.reloadEntity().then(() => {
                                        that._conversationHistoryComp.scrollAndFocusComponent();
                                        General.Events.trigger(EventType.Custom, { cmd: "refreshDocuments" });
                                    })
                                }).then();
                            } else {
                                for (let i = 0; i < files.length; i++) {
                                    await uploadDocument(null, files[i], DocumentReferenceType.Ticket, that.props.entity.ProblemNr, true, null);
                                }
                                that.props.context.reloadEntity().then(() => {
                                    that._conversationHistoryComp.scrollAndFocusComponent();
                                    General.Events.trigger(EventType.Custom, { cmd: "refreshDocuments" });
                                })
                            }
                        }
                    }
                }
            });
        }
    }

    render() {
        return (
            this.props.context.conversationMode ? this._renderConversation() : this._renderTextArea()
        );
    }
}